import { createRouter, createWebHistory } from 'vue-router'
import CarsView from '@/views/CarsView.vue'

const routes = [
  {
    path: '/',
    name: 'cars',
    component: CarsView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  routes
})

export default router
